<template>
  <div>
    <div class="career-opportunity-page">
      <Breadcrumb
        :items="[
          { url: '/', title: 'Home' },
          { url: '/careers', title: 'Careers' },
          { url: route.fullPath, title: data?.title ?? '' }
        ]"
        class="d-none d-lg-block"
      />
      <PageContent v-if="data" :sidebar="true" :sidebar-table-of-content="false">
        <template #sidebar>
          <div class="main-content-sidebar">
            <div>
              <h3>{{ data.title }}</h3>
            </div>
            <div v-if="data.departments.length > 0">
              <h6>Department: {{ openPosition?.department }}</h6>
            </div>
            <div v-if="data.location.name.length > 0">
              <h6>Offices: {{ locations }}</h6>
            </div>
            <br />
            <div v-html="decodedContent"></div>
            <div class="card rounded">
              <div class="card-body p-0">
                <div class="row">
                  <div class="col-1 text-center mt-1">
                    <IconNotification />
                  </div>
                  <div class="col-11">
                    <h5 class="fw-bold">Create a Job Alert</h5>
                    <p>
                      Interested in building your career at Manatt, Phelps and Phillips? Get future
                      opportunities sent straight to your email.<br />
                      <a
                        class="text-decoration-underline"
                        href="https://my.greenhouse.io/users/sign_in?job_board=manattphelpsphillips&source=job_alert_post"
                        target="_blank"
                        >Create alert</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sidebar">
            <div
              ><h3>Contact</h3
              ><span id="2d0c58af-fe05-50d8-bce9-68ae5da9860b"
                ><div
                  ><div class="person-info border p-3"
                    ><div
                      ><span
                        ><strong
                          ><h4><strong>Recruiting</strong></h4></strong
                        ></span
                      ></div
                    ><!----><div class="address mb-3"
                      ><span><!----></span></div
                    ><div class="actions"
                      ><div class="d-flex mb-2"
                        ><svg
                          fill="none"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.7388 16.4137C21.5716 17.6841 20.9477 18.8501 19.9837 19.6941C19.0196 20.5381 17.7813 21.0023 16.5 21C9.05626 21 3.00001 14.9437 3.00001 7.49999C2.99771 6.2187 3.4619 4.98039 4.30588 4.01633C5.14986 3.05228 6.31592 2.42841 7.58626 2.26124C7.9075 2.22202 8.2328 2.28774 8.51362 2.44859C8.79444 2.60944 9.0157 2.8568 9.14438 3.15374L11.1244 7.57406V7.58531C11.2229 7.81261 11.2636 8.06077 11.2428 8.30763C11.222 8.55449 11.1404 8.79236 11.0053 8.99999C10.9884 9.02531 10.9706 9.04874 10.9519 9.07218L9.00001 11.3859C9.7022 12.8128 11.1947 14.2922 12.6403 14.9962L14.9222 13.0547C14.9446 13.0358 14.9681 13.0183 14.9925 13.0022C15.2 12.8638 15.4387 12.7793 15.687 12.7564C15.9353 12.7335 16.1854 12.7729 16.4147 12.8709L16.4269 12.8766L20.8434 14.8556C21.1409 14.9838 21.3889 15.2049 21.5503 15.4858C21.7116 15.7666 21.7778 16.0922 21.7388 16.4137Z"
                            fill="#333333"
                          ></path></svg
                        ><span
                          ><span class="d-inline-block ms-1 contact-item"
                            ><p>310.312.4000</p></span
                          ></span
                        ></div
                      ><div class="d-flex mb-3"
                        ><svg
                          fill="none"
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 4.5H3C2.80109 4.5 2.61032 4.57902 2.46967 4.71967C2.32902 4.86032 2.25 5.05109 2.25 5.25V18C2.25 18.3978 2.40804 18.7794 2.68934 19.0607C2.97064 19.342 3.35218 19.5 3.75 19.5H20.25C20.6478 19.5 21.0294 19.342 21.3107 19.0607C21.592 18.7794 21.75 18.3978 21.75 18V5.25C21.75 5.05109 21.671 4.86032 21.5303 4.71967C21.3897 4.57902 21.1989 4.5 21 4.5ZM9.25406 12L3.75 17.0447V6.95531L9.25406 12ZM10.3641 13.0172L11.4891 14.0531C11.6274 14.1801 11.8084 14.2506 11.9963 14.2506C12.1841 14.2506 12.3651 14.1801 12.5034 14.0531L13.6284 13.0172L19.0659 18H4.92844L10.3641 13.0172ZM14.7459 12L20.25 6.95438V17.0456L14.7459 12Z"
                            fill="#333333"
                          ></path></svg
                        ><span
                          ><span class="d-inline-block ms-1 contact-item"
                            ><p>{{ email }}</p></span
                          ></span
                        ></div
                      ></div
                    ></div
                  ></div
                ></span
              ></div
            >
            <ShareButtons :url="url.href" />
            <div
              ><div class="call-to-action mt-1"
                ><button class="btn btn-manatt-black" @click="applyNow()">Apply Now</button></div
              ></div
            >
          </div>
        </template>
        <template #content>
          <div class="main-content">
            <div>
              <h3>{{ data.title }}</h3>
            </div>
            <div v-if="data.departments.length > 0">
              <h6>Department: {{ openPosition?.department }}</h6>
            </div>
            <div v-if="data.location.name.length > 0">
              <h6>Offices: {{ locations }}</h6>
            </div>
            <br />
            <div v-html="decodedContent"></div>
            <div class="card rounded">
              <div class="card-body p-0">
                <div class="row">
                  <div class="col-lg-1 col-md-2 text-center mt-1">
                    <IconNotification />
                  </div>
                  <div class="col-lg-11 col-md-10">
                    <h5 class="fw-bold">Create a Job Alert</h5>
                    <p>
                      Interested in building your career at Manatt, Phelps and Phillips? Get future
                      opportunities sent straight to your email.<br />
                      <a
                        class="text-decoration-underline"
                        href="https://my.greenhouse.io/users/sign_in?job_board=manattphelpsphillips&source=job_alert_post"
                        target="_blank"
                        >Create alert</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #break>
          <div id="apply-now" class="break-component">
            <div class="container py-4">
              <!-- Error message -->
              <div v-if="submitError" class="alert alert-danger mb-4" role="alert">
                {{ submitError }}
              </div>

              <!-- Success message -->
              <div v-if="submitSuccess" class="card shadow-sm border-success mb-4">
                <div class="card-body">
                  <h3 class="card-title text-success mb-3">
                    Thank you! Your application was submitted.
                  </h3>
                  <p class="mb-2">
                    We’ve received your application for <strong>{{ data.title }}</strong> and our
                    recruiting team will review your information and contact you if your
                    qualifications match our needs.
                  </p>
                  <p class="mb-3">
                    You may close this page or continue browsing our open positions.
                  </p>
                  <div class="d-flex gap-2">
                    <NuxtLink class="btn btn-manatt-black" to="/careers/current-opportunities"
                      >Back to Listings</NuxtLink
                    >
                    <button
                      class="btn btn-bordered btn-outlined-black"
                      type="button"
                      @click="submitSuccess = false"
                    >
                      Submit another response
                    </button>
                  </div>
                </div>
              </div>

              <!-- Wizard -->
              <FormWizard
                v-else
                :exclude-fields="excludedFieldNames"
                :groups="questionGroups"
                :submitting="isSubmitting"
                @submit="onWizardSubmit"
              />
            </div>
          </div>
        </template>
      </PageContent>
    </div>
  </div>
</template>
<script lang="ts" setup>
import he from 'he'
import type { JobItem } from '~/models/greenhouse/JobItem.ts'
import type { OpenPositionSearchRequest } from '~/types/search-types/OpenPositionSearchRequest'
import { fetchOpenPositionSearch } from '~/utils/search-utils'
import { computed, ref } from 'vue'
import PageContent from '../../../../components/ad-hocs/PageContent.vue'

const { scrollToElementById } = useSmoothScroll()
const route = useRoute()
const url = useRequestURL()
const jobId = route.params.jobId

const { data } = await useFetch<JobItem>(`/api/greenhouse/${jobId}`)
const role = await useFetch<string>(`/api/greenhouse/role?jobId=${data.value?.internal_job_id}`)

// Fetch education data if education is required or optional
const { data: schools } = await useFetch<any>('/api/greenhouse/education/schools', {
  lazy: true,
  server: false,
  immediate: data.value?.education !== 'education_hidden'
})
const { data: degrees } = await useFetch<any>('/api/greenhouse/education/degrees', {
  lazy: true,
  server: false,
  immediate: data.value?.education !== 'education_hidden'
})
const { data: disciplines } = await useFetch<any>('/api/greenhouse/education/disciplines', {
  lazy: true,
  server: false,
  immediate: data.value?.education !== 'education_hidden'
})

const pageTitle = ref<string>('')
pageTitle.value = data?.value?.title

useHead({ title: pageTitle })

const isConsultant = role.data.value == 'consultant'

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found'
  })
}

const decodedContent = computed(() => {
  if (!data.value?.content) return ''
  return he.decode(data.value.content)
})

function applyNow() {
  scrollToElementById('apply-now', 150, true)
}

const questionGroups = computed(() => {
  const groups: any[] = []
  if (!data.value) return groups

  const allQuestions = data.value.questions ?? []

  const personalInfoLabels = ['First Name', 'Last Name', 'Preferred First Name', 'Email', 'Phone']
  const resumeLabels = ['Resume/CV', 'Cover Letter', 'Transcript', 'Writing Sample']

  // 1. Personal Information
  const piQuestions = allQuestions.filter((q) => personalInfoLabels.includes(q.label))
  if (piQuestions.length > 0) {
    groups.push({
      title: 'Personal Information',
      questions: piQuestions
    })
  }

  // 2. Resume
  const resumeQuestions = allQuestions.filter((q) => resumeLabels.includes(q.label))
  if (resumeQuestions.length > 0) {
    groups.push({
      title: 'Resume/CV, Cover Letter, Transcript, Writing Sample',
      questions: resumeQuestions
    })
  }

  // 3. Questionnaire (everything else from questions array)
  if (data.value.education && data.value.education !== 'education_hidden') {
    groups.push({
      title: 'Education',
      questions: [
        {
          label: '',
          required: data.value.education === 'education_required',
          fields: [
            {
              name: 'educations',
              type: 'education_repeater',
              values: {
                schools: (schools.value as any)?.items || [],
                degrees: (degrees.value as any)?.items || [],
                disciplines: (disciplines.value as any)?.items || []
              } as any
            }
          ]
        }
      ]
    })
  }

  // 3. Education (if required or optional)
  const questionnaireQuestions = allQuestions.filter(
    (q) => !personalInfoLabels.includes(q.label) && !resumeLabels.includes(q.label)
  )
  if (questionnaireQuestions.length > 0) {
    groups.push({
      title: 'Questionnaire',
      questions: questionnaireQuestions
    })
  }

  // 4. Compliance (from compliance array)
  const complianceItems = data.value.compliance ?? []
  if (complianceItems.length > 0) {
    const combinedDescription = complianceItems
      .map((c: any) => (c?.description ? he.decode(String(c.description)) : ''))
      .filter((s: string) => s && s.trim().length > 0)
      .join('<hr/>')

    const combinedQuestions = complianceItems.flatMap((c: any) =>
      Array.isArray(c?.questions) ? c.questions : []
    )

    if (combinedQuestions.length > 0 || combinedDescription) {
      groups.push({
        title: 'Compliance',
        description: combinedDescription || null,
        questions: combinedQuestions
      })
    }
  }

  return groups
})

// Optional: names of fields to hide/exclude entirely from the form and submission
const excludedFieldNames: string[] = ['resume_text', 'cover_letter_text']

// Submission UI state
const isSubmitting = ref(false)
const submitSuccess = ref(false)
const submitError = ref<string | null>(null)

const email = computed(() => (isConsultant ? 'SG-consulting@manatt.com' : 'recruiting@manatt.com'))
const locations = computed(() => {
  //Los Angeles, California, United States; Sacramento, California, United States
  // display city name only
  return data.value?.location.name
    ?.split(';')
    .map((loc) => {
      const parts = loc.split(',')
      if (parts.length > 1 && parts[1].trim() === 'District of Columbia') {
        return 'Washington, D.C.'
      }
      return parts[0].trim()
    })
    .join('; ')
})

const openPosition = await getOpenPosition(jobId)

async function getOpenPosition(jobId: string) {
  const body: OpenPositionSearchRequest = {
    id: jobId,
    searchValue: undefined,
    selectedSortValue: 'asc',
    page: 1,
    size: 1
  }
  const response = await fetchOpenPositionSearch(body)

  return response.data?.items[0]
}

async function onWizardSubmit(payload: Record<string, any>) {
  // Prevent multiple submissions
  if (isSubmitting.value) return
  submitError.value = null

  // Build a flat JSON object for submission using field names.
  // Source the fields from questionGroups rather than data.value.questions so that
  // client-synthesized steps are included — notably the education repeater, which
  // Greenhouse exposes as a top-level `education` flag instead of a question.
  const submission: Record<string, any> = {}
  const files: Record<string, File | File[]> = {}

  const allQuestions = questionGroups.value.flatMap((g: any) =>
    Array.isArray(g?.questions) ? g.questions : []
  )
  const excluded = new Set(excludedFieldNames)
  for (const q of allQuestions) {
    const fields = q?.fields ?? []
    for (const f of fields) {
      const key = f?.name
      if (!key) continue
      if (excluded.has(key)) continue
      const raw = payload[key]

      // Special handling for Education repeater.
      // Only entries with a school resolved from the Greenhouse autocomplete are sent —
      // the API accepts school_name_id, not free text. The wizard blocks submission on a
      // partially filled entry, so anything dropped here is an untouched blank row.
      if (f.type === 'education_repeater') {
        if (Array.isArray(raw)) {
          submission[key] = raw.filter((e: any) => e.school_name_id)
        }
        continue
      }

      // Collect files separately; do not include in JSON body
      if (f.type === 'input_file') {
        if (raw instanceof File || Array.isArray(raw)) {
          files[key] = raw as any
        }
        continue
      }

      // Normalize values
      let value: any = raw

      // Convert booleans (e.g., checkboxes) to 1/0 to match example
      if (typeof value === 'boolean') {
        value = value ? 1 : 0
      }

      // Default null/undefined to empty string
      if (value === undefined || value === null) {
        value = ''
      }

      // Trim strings
      if (typeof value === 'string') {
        value = value.trim()
      }

      submission[key] = value
    }
  }

  // Build multipart form-data for server proxy → Greenhouse Job Board API
  const form = new FormData()
  // Pass job_id for server routing (not forwarded to GH body)
  form.append('job_id', String(jobId))

  // Greenhouse tracking token
  const ghSrc = route.query.gh_src
  if (ghSrc) {
    form.append('mapped_url_token', String(ghSrc))
  }

  // Append JSON fields
  for (const [key, val] of Object.entries(submission)) {
    if (key === 'educations') {
      // Greenhouse parses multipart params Rails-style: educations[][key] builds an array
      // of hashes, starting a new hash each time a key repeats. Indexed keys
      // (educations[0][key]) would instead produce a hash keyed by "0" and the API
      // rejects it. All seven keys are appended for every entry, in a fixed order, so the
      // grouping is unambiguous — validation guarantees no entry reaches here half-filled.
      if (Array.isArray(val)) {
        for (const entry of val) {
          form.append('educations[][school_name_id]', String(entry.school_name_id))
          form.append('educations[][degree_id]', String(entry.degree_id))
          form.append('educations[][discipline_id]', String(entry.discipline_id))
          form.append('educations[][start_date][month]', String(entry.start_date?.month))
          form.append('educations[][start_date][year]', String(entry.start_date?.year))
          form.append('educations[][end_date][month]', String(entry.end_date?.month))
          form.append('educations[][end_date][year]', String(entry.end_date?.year))
        }
      }
    } else if (Array.isArray(val)) {
      // repeat keys for array values
      for (const item of val) form.append(key, item == null ? '' : String(item))
    } else {
      form.append(key, val == null ? '' : String(val))
    }
  }

  // Append files (resume/cover_letter/etc.) — Greenhouse expects single file per field
  for (const [key, fileVal] of Object.entries(files)) {
    if (Array.isArray(fileVal)) {
      if (fileVal.length > 0) form.append(key, fileVal[0])
    } else if (fileVal instanceof File) {
      form.append(key, fileVal)
    }
  }

  try {
    isSubmitting.value = true

    // Note: Route typing may narrow this endpoint to GET at build time.
    // Cast options to any to allow POST for this server route.
    const res = await $fetch('/api/greenhouse/apply', {
      method: 'POST',
      body: form
    } as any)

    submitSuccess.value = true
    // Optionally scroll to the success card
    nextTick(() => scrollToElementById('apply-now', 150, true))
  } catch (err: any) {
    console.error('Application submission failed', err)
    // Friendly error message
    let msg = 'Sorry, there was a problem submitting your application. Please try again later.'
    const serverMsg = (err && (err.data?.message || err.message)) as unknown
    if (typeof serverMsg === 'string' && serverMsg.trim().length > 0) {
      msg = serverMsg
    }
    submitError.value = msg
  } finally {
    isSubmitting.value = false
  }
}
</script>
<style lang="scss">
.career-opportunity-page {
  svg.location path {
    fill: var(--theme-orange);
  }

  .pay-input .title {
    font-weight: 700;
  }
}
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
}
</style>
